import { render, staticRenderFns } from "./SdLogin.vue?vue&type=template&id=4b4ead3c&scoped=true&"
import script from "./SdLogin.vue?vue&type=script&lang=js&"
export * from "./SdLogin.vue?vue&type=script&lang=js&"
import style0 from "./SdLogin.vue?vue&type=style&index=0&id=4b4ead3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ead3c",
  null
  
)

export default component.exports